import React, { Component } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import api from "../../utils/Api";
import history from "../../utils/history";
import Type from "./Type/Type";
import IndividualInfo from "./IndividualInfo/IndividualInfo";
import CompanyInfo from "./CompanyInfo/CompanyInfo";
import BankDetails from "./BankDetails/BankDetails";
import UploadDocuments from "./UploadDocuments/UploadDocuments";
import { DisplayFormikState } from "../../utils/helper";
import { connect } from "react-redux";
import { fetchRelatedParty } from "../../redux/";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import ExternalPractitionerInfo from "./ExternalPractitionerInfo/ExternalPractitionerInfo";
import { NAME_MESSAGE, NAME_REGEX } from "../../utils/RegexConstants";

let initialValues = {
  partyType: "individual",
  indvRelatedPartyRole: "",
  indvProfessionalService: "",
  title: "",
  firstName: "",
  lastName: "",
  gender: "",
  dateOfBirth: moment(null).isBefore(),
  passportNumber: "",
  physicalAddress: "",
  postalAddress: "",
  cellNumber: "",
  emailAddress: "",
  room_id: "",
  // southAId: false,
  IdNumber: "",
  patientType: "privatePatient",
  medicalAidScheme: "",
  medicalAidNumber: "",
  medicalAidPlan: "",
  medicalAidPlanOption:"",
  medicalAidPlanSubOption:"",
  medicalIDNumber:"",
  patientRelationship:"",
  //mainMember: "",
  //referringPractitioner: "",
  communication: "sms",
  cRelatedPartyRole: "",
  cProfessionalService: "",
  companyName: "",
  lineOfBusiness: "",
  servicesOfffered: "",
  registrationNumber: "",
  compEmailAddress: "",
  contactPerson: "",
  accNameHolder: "",
  bank: "",
  accNumber: "",
  accType: "",
  branchCode: "",
  country: "",
  swiftCode: "",
  systemUserCheck: false,
  systemRoleParty: "",
  assigned_roles: [],
  uploadDocs: [],
  initialValuesUpdated: false,
  billing_practise_pcns_number: "",
  discipline_code: null,
  discipline_name: "",
  vat_registration_number: "",
  cms_registration_number: "",
  main_surgeon:0,
  assistant:0,
  anaesthetist:0,
  locum:0,
  referring_practitioner:0
};

class RelatedPartySave extends Component {

  componentDidMount = async()=>{
    document.title = 'Edit Contact - TechToMedix';
    if (this.props.match.params.id) {
     await this.props.fetchRelatedParty(this.props.match.params.id);
     this.setInitialValue(this.props.relatedPartyData.relatedPartyData);
    }else{
      this.setInitialValue({});
      this.setState(() => ({
              pageIndex: 0,
              schemaArray: [
                this.Step1Schema,
                this.Step2Schema,
                this.Step3Schema,
                this.Step4Schema,
              ],
            }));
    }
    
  }

  componentDidUpdate(prevProps, prevState) {
    //document.title = 'TechToMed - Edit Contact';
    if (prevProps.match.params.id != this.props.match.params.id) {
      this.setInitialValue({});

      this.setState(() => ({
        pageIndex: 0,
        schemaArray: [
          this.Step1Schema,
          this.Step2Schema,
          this.Step3Schema,
          this.Step4Schema,
        ],
      }));
    }
  }

  // Validation schema for patry type
  Step1Schema = Yup.object().shape({
    partyType: Yup.string().required("Type Is Required"),
  });

  // Validation schema for individual information
  Step2Schema = Yup.object().shape({
    emailAddress: Yup.string().trim()
      .email("Email is invalid")
      .required("Email is required"),
    title: Yup.string().required("Title is required"),
    indvRelatedPartyRole: Yup.string().required(
      "Role of the contact is required"
    ),
    indvProfessionalService: Yup.string().when("indvRelatedPartyRole", {
      is: (value) => value === "5",
      then: Yup.string()
        .required("Professional Service is required")
        .nullable(),
      otherwise: Yup.string().nullable(),
    }),
    firstName: Yup.string().trim()
      .required("First Name is required")
      .matches(NAME_REGEX, NAME_MESSAGE),
    lastName: Yup.string().trim()
      .required("Last Name is required")
      .matches(NAME_REGEX, NAME_MESSAGE),
    gender: Yup.string().required("Gender is required"),
    //dateOfBirth: Yup.string().required("Date Of Birth is required").nullable(),
    cellNumber: Yup.string().trim()
      .required("Cell Phone Number is required")
      .matches(/^\d+$/, "Only numbers allowed")
      .min(10, "Must be exactly 10 digits"),
    room_id: Yup.string().when("indvRelatedPartyRole", {
      is: (value) => value === "3",
      then: Yup.string()
        .required("Room is required"),
      otherwise: Yup.string().nullable(),
    }),
    // mainMember: Yup.string().trim()
    //   .matches(/^[a-zA-Z ]*$/, "Enter alphabets only"),
    // referringPractitioner: Yup.string().trim()
    //     .matches(/^[a-zA-Z ]*$/, "Enter alphabets only"),
    medicalAidScheme: Yup.string().when("patientType", {
      is: (value) => value === "medicalAid",
      then: Yup.string()
        .required("Medical Aid Scheme is required"),
      otherwise: Yup.string().nullable(),
    }), 
    medicalAidNumber: Yup.string().when("patientType", {
      is: (value) => value === "medicalAid",
      then: Yup.string()
      .trim()
      .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed")
        .required("Medical Aid Number is required"),
      otherwise: Yup.string().nullable(),
    }),
    medicalAidPlan: Yup.string().when("patientType", {
      is: (value) => value === "medicalAid",
      then: Yup.string()
        .required("Medical Aid Plan is required"),
      otherwise: Yup.string().nullable(),
    }),
    
  // medicalAidPlanOption: Yup.string().when("patientType", {
  //   is: (value) => value === "medicalAid",
  //   then: Yup.string()
  //     .required("Medical Aid Plan Option is required"),
  //   otherwise: Yup.string().nullable(),
  // }),
  // medicalAidPlanSubOption: Yup.string().when("patientType", {
  //   is: (value) => value === "medicalAid",
  //   then: Yup.string()
  //     .required("Medical Aid Plan Sub Option is required"),
  //   otherwise: Yup.string().nullable(),
  // }),
  medicalIDNumber: Yup.string().when("patientType", {
    is: (value) => value === "medicalAid",
    then: Yup.string()
      .required("Medical ID/Passport is required")
      .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed"),
    otherwise: Yup.string().nullable(),
  }),
  patientRelationship: Yup.string().when("patientType", {
    is: (value) => value === "medicalAid",
    then: Yup.string()
      .required("Patient Relationship is required"),
    otherwise: Yup.string().nullable(),
  }),
    systemRoleParty: Yup.string().when("assigned_roles", {
      is: (value) => value.length > 0,
      then: Yup.string()
        .required("Primary system role is required"),
    }),
  });

  // Validation schema for company information
  Step2SchemaForOrganizationType = Yup.object().shape({
    cRelatedPartyRole: Yup.string().required("Role of the contact is required"),
    cProfessionalService: Yup.string().when("cRelatedPartyRole", {
      is: (value) => value === "5",
      then: Yup.string()
        .required("Professional Service is required")
        .nullable(),
      otherwise: Yup.string().nullable(),
    }),
    companyName: Yup.string().trim()
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter alphanumeric values only")
    .required("Company Name is required"),
    lineOfBusiness: Yup.string().required("Line Of Business is required"),
    servicesOfffered: Yup.string().trim()
    .matches(/^[a-zA-Z ]*$/, "Enter alphabets only")
    .required("Services Offfered is required"),
    registrationNumber: Yup.string().trim().required(
      "Registration Number is required"
    )
    .matches(/^[0-9]*$/, "Only numbers allowed"),
    physicalAddress: Yup.string().trim().required("Physical Address is required"),
    cellNumber: Yup.string().trim()
      .required("Cell Phone Number is required")
      .matches(/^\d+$/, "Only numbers allowed")
      .min(10, "Must be exactly 10 digits"),
    compEmailAddress: Yup.string().trim()
      .email("Email is invalid")
      .required("Email is required"),
    contactPerson: Yup.string().trim()
    .matches(NAME_REGEX, NAME_MESSAGE),
    systemRoleParty: Yup.string().when("assigned_roles", {
      is: (value) => value.length > 0,
      then: Yup.string()
        .required("Primary system role is required"),
    }),
  });

  // Validation schema for company information
  Step2SchemaForExternalPractitionerType = Yup.object().shape({
    emailAddress: Yup.string().trim()
      .email("Email is invalid")
      .required("Email is required"),
    title: Yup.string().required("Title is required"),
    firstName: Yup.string().trim()
      .required("First Name is required")
      .matches(NAME_REGEX, NAME_MESSAGE),
    lastName: Yup.string().trim()
      .required("Last Name is required")
      .matches(NAME_REGEX, NAME_MESSAGE),
    cellNumber: Yup.string().trim()
      .required("Cell Phone Number is required")
      .matches(/^\d+$/, "Only numbers allowed")
      .min(10, "Must be exactly 10 digits"),
    discipline_code: Yup.string()
      .required("Practice Type is required")
      .nullable(),
    billing_practise_pcns_number: Yup.string()
      .required("PCNS number is required")
      .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed")
      .nullable(),
    cms_registration_number: Yup.string()
      .required("CMS Registration number is required")
      .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed")
      .nullable(),
  });

  // Validation schema for bank details
  Step3Schema = Yup.object().shape({
    accNameHolder: Yup.string().trim()
     // .required("Name is required")
      .matches(NAME_REGEX, NAME_MESSAGE).nullable(),
    //bank: Yup.string().trim().required("Bank name is required"),
    accNumber: Yup.string().trim()
     // .required("Account Number is required")
      .matches(/^\d+$/, "Only numbers allowed").nullable(),
   //accType: Yup.string().required("Account Type is required"),
    branchCode: Yup.string().trim()
     // .required("Branch Code is required")
      .matches(/^[a-zA-Z0-9 ]*$/, "Special symbols are not allowed").nullable(),
    //country: Yup.string().required("Country is required"),
    swiftCode: Yup.string().trim().matches(/^\d+$/, "Only numbers allowed").nullable(),
  });

  Step4Schema = Yup.object({});
  // Yup.object({
  //   systemRoleParty: Yup.number().when("systemUserCheck", {
  //     is: true,
  //     then: Yup.number().required("System role party is required"),
  //   }),
  //});

  handleInputSystemRole = (arr) => {
   // console.log("func called!", arr);
    initialValues.assigned_roles = [...arr];
    this.setState({
      initialValuesUpdated: !this.state.initialValuesUpdated
    });
    if(arr.length === 0 || (arr.indexOf(initialValues.systemRoleParty) === -1)){
      initialValues.systemRoleParty = ""
      this.setState({
        initialValuesUpdated: !this.state.initialValuesUpdated
      });
    //  console.log("initialValues", initialValues);
    }
  };

  state = {
    pageIndex: 0,
    schemaArray: [
      this.Step1Schema,
      this.Step2Schema,
      this.Step3Schema,
      this.Step4Schema,
    ],
    statusSuccessMessage: "",
    statusErrorMessage: "",
    loadingState: false,
  };


  save = async (data) => {
    
    this.setState({
      loadingState: true,
      statusErrorMessage: "",
    });
    const headers = {
      "content-type": "multipart/form-data",
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };

    let relatedPartyData,
      medicalAidParams,
      medicalAidData,
      relatedPartyRoleParams,
      relatedPartyRoleData;

    medicalAidParams = {
      scheme_code: data.medicalAidScheme,
      membership_number: data.medicalAidNumber,
      scheme_plan_code: data.medicalAidPlan,
      scheme_plan_option_code: data.medicalAidPlanOption,
      scheme_plansuboption_code: data.medicalAidPlanSubOption,
      membership_passport_number: data.medicalIDNumber,
      patient_relationship_code: data.patientRelationship,
    };

    relatedPartyRoleParams = {
      isMedicalAidPatient: data.patientType === "medicalAid" ? 1 : 0,
    };

    // if patient role selected
    relatedPartyRoleData =
      data.indvRelatedPartyRole === "4" ? relatedPartyRoleParams : {};

    // if patient type medicalaid selected
    medicalAidData = data.patientType === "medicalAid" ? medicalAidParams : {};

    if (data.partyType === "individual") {
      let firstName = data.firstName.trim();
      let lastName = data.lastName.trim();
      relatedPartyData = {
        title: data.title,
        name: firstName,
        surname: lastName,
        gender: data.gender,
        dob: data.dateOfBirth ? moment(data.dateOfBirth).format("YYYY-MM-DD") : null,
        passport_number: data.passportNumber,
        physical_address: data.physicalAddress,
        postal_address: data.postalAddress,
        contact_number: data.cellNumber,
        email: data.emailAddress,
       // main_member: data.mainMember,
        //referring_practioner: data.referringPractitioner,
        communication_mode: data.communication,
        related_party_type: data.partyType,
        lk_related_party_role_id: data.indvRelatedPartyRole,
        lk_professional_service_id: data.indvProfessionalService,
        isSystemUser: (data.systemRoleParty==="") ? 0 : 1,
        south_african_id: data.IdNumber,
        system_role_id:
          data.systemRoleParty === "" ? null : data.systemRoleParty,
      };
      if(data.indvRelatedPartyRole == "3"){
        relatedPartyData.room_id = data.room_id;
      }
    }else if(data.partyType === "external_practitioner"){
      let firstName = data.firstName.trim();
      let lastName = data.lastName.trim();
      relatedPartyData = {
        title: data.title,
        name: firstName,
        surname: lastName,
        physical_address: data.physicalAddress,
        postal_address: data.postalAddress,
        contact_number: data.cellNumber,
        email: data.emailAddress,
        related_party_type: data.partyType,
        lk_related_party_role_id: 11,
      };
    } else {
      relatedPartyData = {
        name: data.companyName,
        business_industry_id: data.lineOfBusiness,
        services_offered: data.servicesOfffered,
        registration_number: data.registrationNumber,
        physical_address: data.physicalAddress,
        postal_address: data.postalAddress,
        contact_number: data.cellNumber,
        email: data.compEmailAddress,
        contact_person: data.contactPerson,
        related_party_type: data.partyType,
        lk_related_party_role_id: data.cRelatedPartyRole,
        lk_professional_service_id:
          data.cProfessionalService == "" ? null : data.cProfessionalService,
          isSystemUser: (data.systemUserCheck || data.systemRoleParty) ? 1 : 0,
        system_role_id:
          data.systemRoleParty === "" ? null : data.systemRoleParty,
      };
    }

    let bankdetails = {};
    if(data.accNameHolder || data.bank || data.accNumber || 
      data.accType || data.branchCode || data.country || data.swiftCode){
        bankdetails = {
        account_holder_name: data.accNameHolder,
        lk_bank_id: data.bank,
        account_number: data.accNumber,
        account_type: data.accType,
        branch_code: data.branchCode,
        country_id: data.country ? data.country : null,
        swift_bic_code: data.swiftCode,
      }
    }

    
    const payload = {
      relatedPartyDetails: {
        ...relatedPartyData,
        ...medicalAidData,
        ...relatedPartyRoleData,
      },
      assigned_roles: data.assigned_roles?data.assigned_roles:[],
      bankDetails: {...bankdetails},
      role_id: data.systemRoleParty,
    };
    if (data.isEditMode) {
      payload.relatedPartyDetails.related_party_id = this.props.match.params.id;
    }

    const formData = new FormData();
    const attachmentData = [];
    data.uploadDocs.map((element, index) => {
      if (element.isNewUpload) {
        formData.append("attachment", element.selectedFile);
        formData.append("description", element.description);
      } else {
        attachmentData.push({
          attachment_id: element.attachment_id,
          description: element.description,
          delete: element.delete,
        });
      }
    });

    let externalPractitioner = {};
    if(data.partyType === "external_practitioner"){
      let firstName = data.firstName.trim();
      let lastName = data.lastName.trim();
      externalPractitioner = {
        registration_name: firstName + ( lastName ? " " + lastName: "") ,
        billing_practise_pcns_number: data.billing_practise_pcns_number,
        vat_registration_number: data.vat_registration_number,
        discipline_code: data.discipline_code,
        discipline_name: data.discipline_name,
        cms_registration_number: data.cms_registration_number,
        main_surgeon: data.main_surgeon === 1 ?  1 : 0 ,
        assistant: data.assistant === 1 ?  1 : 0 ,
        anaesthetist: data.anaesthetist === 1 ?  1 : 0 ,
        locum: data.locum === 1 ?  1 : 0 ,
        referring_practitioner: data.referring_practitioner === 1 ?  1 : 0 
      }
    formData.append("externalPractitioner", JSON.stringify({ ...externalPractitioner }));
    }

    formData.append("attachmentData", JSON.stringify(attachmentData));
    formData.append(
      "relatedPartyDetails",
      JSON.stringify({ ...payload.relatedPartyDetails })
    );
    formData.append("bankDetails", JSON.stringify({ ...payload.bankDetails }));
    formData.append("role_id", payload.role_id);
    let array = [...payload.assigned_roles];
    formData.append("assigned_roles", JSON.stringify(array));

    try {
      const response = await api.post("relatedparty", formData, {
        headers: headers,
      });
     // console.log("Contact Response - ", response);
      // Page redirect to dashboard
      if (response.status === 200) {
        this.setState({
          loadingState: false,
          statusSuccessMessage: data.isEditMode
            ? "Contact updated successfully! Please wait while redirecting..."
            : "Contact created successfully! Please wait while redirecting...",
        });
        setTimeout(() => {
          history.push("/contacts");
        }, 5000);
      }
    } catch (error) {
      this.setState({
        loadingState: false,
        statusErrorMessage: error.response
          ? error.response.data.message
          : "Contact creation failed! Please try again later...",
      });
      // setTimeout(() => {
      //   this.setState({
      //     statusErrorMessage: "",
      //   });
      // }, 2000);
    }
  };


  setInitialValue = (relatedPartyData) => {
    
    this.setState({
      initialValuesUpdated: false
    })
    const isRelatedPartyEmpty = !Object.keys(relatedPartyData).length;
    let relatedPartyDetails, bankDetails, attachment, externalPractitioner;
    if (!isRelatedPartyEmpty) {
      relatedPartyDetails = relatedPartyData.relatedPartyDetails;
      bankDetails = relatedPartyData.bankDetails;
      attachment = relatedPartyData.attachment;
      externalPractitioner = relatedPartyData.externalPractitioner;
    }

    initialValues = {
      partyType: isRelatedPartyEmpty
        ? "individual"
        : relatedPartyDetails.related_party_type,
      indvRelatedPartyRole: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.lk_related_party_role_id,
      indvProfessionalService: isRelatedPartyEmpty
        ? null
        : relatedPartyDetails.lk_professional_service_id,
      title: isRelatedPartyEmpty ? "" : relatedPartyDetails.title,
      firstName: isRelatedPartyEmpty ? "" : relatedPartyDetails.name,
      lastName: isRelatedPartyEmpty ? "" : relatedPartyDetails.surname,
      gender: isRelatedPartyEmpty ? "" : relatedPartyDetails.gender,
      room_id: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.room_id,
      dateOfBirth:
        isRelatedPartyEmpty || relatedPartyDetails.dob == null
          ? null
          : moment(relatedPartyDetails.dob).format("YYYY-MM-DD"),
      passportNumber: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.passport_number,
      physicalAddress: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.physical_address,
      postalAddress: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.postal_address,
      cellNumber: isRelatedPartyEmpty ? "" : relatedPartyDetails.contact_number,
      emailAddress: isRelatedPartyEmpty ? "" : relatedPartyDetails.email,
      // southAId:
      //   isRelatedPartyEmpty ||
      //   relatedPartyDetails.south_african_id == "" ||
      //   relatedPartyDetails.south_african_id == null
      //     ? false
      //     : true,
      // IdNumber: isRelatedPartyEmpty ? "" : relatedPartyDetails.south_african_id,
      patientType:
        (isRelatedPartyEmpty ||
        relatedPartyDetails.isMedicalAidPatient == 0 ||
        relatedPartyDetails.isMedicalAidPatient == null)
          ? "privatePatient"
          : "medicalAid",
      medicalAidScheme: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.scheme_code,
      medicalAidNumber: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.membership_number,
      medicalAidPlan: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.scheme_plan_code,
      medicalAidPlanOption: isRelatedPartyEmpty
          ? ""
          : relatedPartyDetails.scheme_plan_option_code,
      medicalAidPlanSubOption: isRelatedPartyEmpty
            ? ""
            : relatedPartyDetails.scheme_plansuboption_code,
      medicalIDNumber: isRelatedPartyEmpty
              ? ""
              : relatedPartyDetails.membership_passport_number,
       patientRelationship: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.patient_relationship_code,
     // mainMember: isRelatedPartyEmpty ? "" : relatedPartyDetails.main_member,
      // referringPractitioner: isRelatedPartyEmpty
      //   ? ""
      //   : relatedPartyDetails.referring_practioner,
      communication: isRelatedPartyEmpty
        ? "sms"
        : relatedPartyDetails.communication_mode,
      cRelatedPartyRole: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.lk_related_party_role_id,
      cProfessionalService: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.lk_professional_service_id,
      companyName: isRelatedPartyEmpty ? "" : relatedPartyDetails.name,
      lineOfBusiness: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.business_industry_id,
      servicesOfffered: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.services_offered,
      registrationNumber: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.registration_number,
      compEmailAddress: isRelatedPartyEmpty ? "" : relatedPartyDetails.email,
      contactPerson: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.contact_person,
      accNameHolder: isRelatedPartyEmpty ? "" : bankDetails && bankDetails.account_holder_name,
      bank: isRelatedPartyEmpty ? "" : bankDetails && bankDetails.lk_bank_id,
      accNumber: isRelatedPartyEmpty ? "" : bankDetails && bankDetails.account_number,
      accType: isRelatedPartyEmpty ? "" : bankDetails && bankDetails.account_type,
      branchCode: isRelatedPartyEmpty ? "" : bankDetails && bankDetails.branch_code,
      country: isRelatedPartyEmpty ? "" : bankDetails && bankDetails.country_id,
      swiftCode: isRelatedPartyEmpty ? "" : bankDetails && bankDetails.swift_bic_code,
      systemUserCheck:
        isRelatedPartyEmpty || relatedPartyDetails.isSystemUser == 0 || relatedPartyDetails.system_role_id == ""
          ? false
          : true,
      assigned_roles: isRelatedPartyEmpty
      ? []
      : relatedPartyData.assigned_roles || [],
      systemRoleParty: isRelatedPartyEmpty
        ? ""
        : relatedPartyDetails.system_role_id || "",
      uploadDocs: [],
      billing_practise_pcns_number:  isRelatedPartyEmpty ? ""
      : (externalPractitioner && externalPractitioner.billing_practise_pcns_number) || "",
      discipline_code: isRelatedPartyEmpty ? ""
      : (externalPractitioner &&  externalPractitioner.discipline_code) || null,
      discipline_name: isRelatedPartyEmpty ? ""
      : (externalPractitioner && externalPractitioner.discipline_name) || "",
      vat_registration_number: isRelatedPartyEmpty ? ""
      : (externalPractitioner && externalPractitioner.vat_registration_number) || "",
      cms_registration_number: isRelatedPartyEmpty ? ""
      : (externalPractitioner && externalPractitioner.cms_registration_number )|| "",
      main_surgeon: isRelatedPartyEmpty ? ""
      : (externalPractitioner && externalPractitioner.main_surgeon) || 0,
      assistant: isRelatedPartyEmpty ? ""
      : (externalPractitioner && externalPractitioner.assistant) || 0,
      anaesthetist: isRelatedPartyEmpty ? ""
      : (externalPractitioner && externalPractitioner.anaesthetist) || 0,
      locum: isRelatedPartyEmpty ? ""
      : (externalPractitioner && externalPractitioner.locum) || 0,
      referring_practitioner: isRelatedPartyEmpty ? ""
      : (externalPractitioner &&  externalPractitioner.referring_practitioner) || 0,
      isEditMode: isRelatedPartyEmpty ? false : true,
    };

    const uploadDocs = [];
    if (initialValues.isEditMode) {
      initialValues["attachment"] = attachment;
      if (attachment) {
        attachment.forEach((element, index) => {
          uploadDocs.push({
            attachment_id: element.attachment_id,
            selectedFile: element.attachment_file_name,
            description: element.description,
            isNewUpload: false,
            delete: 0,
          });
        });
      }
      initialValues.uploadDocs = uploadDocs;
    }
    this.setState({
      initialValuesUpdated: true
    })
  };

  render() {
    return (
      <div>
        <Formik
          initialValues={initialValues}
          validationSchema={this.state.schemaArray[this.state.pageIndex]}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              this.save(values);
              setSubmitting(false);
            }, 1000);
          }}
          enableReinitialize={true}
        >
          {(props) => {
            const { handleSubmit } = props;
            return (
              <form onSubmit={handleSubmit}>
                {this._renderPage(props)}
                {/* {<DisplayFormikState {...props} />} */}
                    </form>
                  );
                }}
        </Formik>
        <div className="contacts-add-message">
                {this.state.loadingState && (
              <div className="loadingWrapper">
                <img alt="loader" src={ttmLoader} />
              </div>
              )}
              <div className="statusSucesssMessage">
                {this.state.statusSuccessMessage}
              </div>
              <div className="statusErrorMessage">
                {this.state.statusErrorMessage}
              </div>
              </div>
      </div>
    );
  }

  _navigateBack = () => {
    this.setState((prevState) => ({
      pageIndex: prevState.pageIndex - 1,
    }));
  };

  _navigateBackStep1 = () => {
    this.setState((prevState) => ({
      pageIndex: 0,
    }));
  };

  _navigateBackStep2 = () => {
    this.setState((prevState) => ({
      pageIndex: 1,
    }));
  };

  _navigateNext = (props) => {
    if (props.isValid) {
      if (props.values.partyType === "organization") {
        this.setState((prevState) => ({
          pageIndex: prevState.pageIndex + 1,
          schemaArray: [
            this.Step1Schema,
            this.Step2SchemaForOrganizationType,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      } else if(props.values.partyType === "external_practitioner"){
        this.setState((prevState) => ({
          pageIndex: prevState.pageIndex + 1,
          schemaArray: [
            this.Step1Schema,
            this.Step2SchemaForExternalPractitionerType,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      }else {
        this.setState((prevState) => ({
          pageIndex: prevState.pageIndex + 1,
          schemaArray: [
            this.Step1Schema,
            this.Step2Schema,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      }

      props.setTouched({});
    }
  };

  _navigateNext = (props) => {
    if (props.isValid) {
      if (props.values.partyType === "organization") {
        this.setState((prevState) => ({
          pageIndex: prevState.pageIndex + 1,
          schemaArray: [
            this.Step1Schema,
            this.Step2SchemaForOrganizationType,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      } else if(props.values.partyType === "external_practitioner"){
        this.setState((prevState) => ({
          pageIndex: prevState.pageIndex + 1,
          schemaArray: [
            this.Step1Schema,
            this.Step2SchemaForExternalPractitionerType,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      } else {
        this.setState((prevState) => ({
          pageIndex: prevState.pageIndex + 1,
          schemaArray: [
            this.Step1Schema,
            this.Step2Schema,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      }

      props.setTouched({});
    }
  };

  _navigateNextStep1 = (props) => {
    if (props.isValid) {
      if (props.values.partyType === "organization") {
        this.setState((prevState) => ({
          pageIndex: 1,
          schemaArray: [
            this.Step1Schema,
            this.Step2SchemaForOrganizationType,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      } else if(props.values.partyType === "external_practitioner"){
        this.setState((prevState) => ({
          pageIndex: 1,
          schemaArray: [
            this.Step1Schema,
            this.Step2SchemaForExternalPractitionerType,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      } else {
        this.setState((prevState) => ({
          pageIndex: 1,
          schemaArray: [
            this.Step1Schema,
            this.Step2Schema,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      }

      props.setTouched({});
    }
  };

  _navigateNextStep2 = (props) => {
    if (props.isValid) {
      if (props.values.partyType === "organization") {
        this.setState((prevState) => ({
          pageIndex: 2,
          schemaArray: [
            this.Step1Schema,
            this.Step2SchemaForOrganizationType,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      } else if(props.values.partyType === "external_practitioner"){
        this.setState((prevState) => ({
          pageIndex: 2,
          schemaArray: [
            this.Step1Schema,
            this.Step2SchemaForExternalPractitionerType,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      } else {
        this.setState((prevState) => ({
          pageIndex: 2,
          schemaArray: [
            this.Step1Schema,
            this.Step2Schema,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      }

      props.setTouched({});
    }
  };

  _navigateNextStep3 = (props) => {
    if (props.isValid) {
      if (props.values.partyType === "organization") {
        this.setState((prevState) => ({
          pageIndex: 3,
          schemaArray: [
            this.Step1Schema,
            this.Step2SchemaForOrganizationType,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      } else if(props.values.partyType === "external_practitioner"){
        this.setState((prevState) => ({
          pageIndex: 3,
          schemaArray: [
            this.Step1Schema,
            this.Step2SchemaForExternalPractitionerType,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      } else {
        this.setState((prevState) => ({
          pageIndex: 3,
          schemaArray: [
            this.Step1Schema,
            this.Step2Schema,
            this.Step3Schema,
            this.Step4Schema,
          ],
        }));
      }

      props.setTouched({});
    }
  };

  _renderPage(props) {
    const { pageIndex } = this.state;
    let renderedPage = props.values.partyType === "individual" ? IndividualInfo : CompanyInfo;
    if(props.values.partyType === "individual"){
      renderedPage = IndividualInfo;
    } else if(props.values.partyType === "organization"){
      renderedPage = CompanyInfo;
    }else{
      renderedPage = ExternalPractitionerInfo;
    }
    const pageHash = {
      0: Type,
      1: renderedPage,
      2: BankDetails,
      3: UploadDocuments,
    };

    const Page = pageHash[pageIndex];

    return (
      <Page
        {...props}
        navigateBack={this._navigateBack}
        navigateBackStep1={this._navigateBackStep1}
        navigateBackStep2={this._navigateBackStep2}
        navigateNext={() =>
          props.validateForm().then((errors) => {
            console.log(errors);
            this._navigateNext(props);
          })
        }
        handleInputSystemRole={this.handleInputSystemRole}
        navigateNextStep1={() =>
          props.validateForm().then((errors) => {
            console.log(errors);
            this._navigateNextStep1(props);
          })
        }
        navigateNextStep2={() =>
          props.validateForm().then((errors) => {
            console.log(errors);
            this._navigateNextStep2(props);
          })
        }
        navigateNextStep3={() =>
          props.validateForm().then((errors) => {
            console.log(errors);
            this._navigateNextStep3(props);
          })
        }
        pageIndex={pageIndex}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    relatedPartyData: state.relatedPartyData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchRelatedParty: (value) => dispatch(fetchRelatedParty(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RelatedPartySave);
